import { BoxV2 as Box } from 'portal-commons';
import { FunctionComponent } from 'react';

interface AddButtonProps {
  onClick?: () => void;
}

const AddButton: FunctionComponent<AddButtonProps> = ({
  onClick,
  children,
}) => (
  <Box
    sx={{
      position: 'absolute',
      top: '44px',
      right: 0,
      color: '#33A7C2',
      fontWeight: 600,
      fontSize: 'H200',
      cursor: 'pointer',
    }}
    onClick={onClick}
  >
    {children}
  </Box>
);

export default AddButton;
